import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moveUsersHeading: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.move-users-heading',
		defaultMessage: 'Move all users to the new issue search',
		description: 'The heading for the move all users toggle',
	},
	moveUsersDescription: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.move-users-description',
		defaultMessage: 'Your users will see the new issue search by default.',
		description: 'The description and instructions for the move all users toggle section',
	},
	toggleFailedHeading: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.toggle-failed-heading',
		defaultMessage: "We couldn't update the transition setting",
		description: 'Message displayed when the lock in issue search transition toggle has failed',
	},
	toggleFailedDescription: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.toggle-failed-description',
		defaultMessage: 'Check your connection, then give it another try.',
		description:
			'Message displayed when the lock in issue search transition toggle fails to update',
	},
	toggleSuccessOnHeading: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.toggle-success-on-heading',
		defaultMessage: 'Your users are now on the new issue search',
		description:
			'Heading displayed when the lock in issue search transition toggle is successfully set on',
	},
	toggleSuccessOffHeading: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.toggle-success-off-heading',
		defaultMessage: 'Your users will stay on the old issue search',
		description:
			'Heading displayed when the lock in issue search transition toggle is successfully set off',
	},
	toggleSuccessOnDescription: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.toggle-success-on-description',
		defaultMessage:
			"We've set up a tour for users so they can easily transition to the new issue search.",
		description:
			'Message displayed when the lock in issue search transition toggle is successfully set on',
	},
	toggleSuccessOffDescription: {
		id: 'admin-pages-new-issue-search-transition.lock-in-transition.toggle-success-off-description',
		defaultMessage:
			'If you want to move your users to the new issue search later, go to {boldStart}Settings > Issues > New issue search{boldEnd}',
		description:
			'Message displayed when the lock in issue search transition toggle is successfully set off',
	},
});
